export class AccountVersion {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "installed",
            "baseName": "installed",
            "type": "string",
            "format": ""
        },
        {
            "name": "installationMethod",
            "baseName": "installationMethod",
            "type": "AccountInstallationMethod",
            "format": ""
        },
        {
            "name": "latest",
            "baseName": "latest",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AccountVersion.attributeTypeMap;
    }
    constructor() {
    }
}
